module.exports = __webpack_public_path__ + "fonts/Proxima Nova Regular.bf9f5d50.otf";